var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechnalogyExpertiesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177",
    transform: "translate(-788 -1322)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(788 1322)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "technology",
    transform: "translate(797.969 1327.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1_17_",
    transform: "translate(-0.001 5.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_19---Technology-Engineering",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_133_",
    d: "M1.118,28.744l2.614.428a16.1,16.1,0,0,0,2.329,5.613L4.514,36.946a1.222,1.222,0,0,0,.014,1.465A17.906,17.906,0,0,0,5.77,39.78c.441.442.9.849,1.365,1.243a1.222,1.222,0,0,0,1.467.014l2.159-1.549a16.071,16.071,0,0,0,5.609,2.331l.428,2.616a1.21,1.21,0,0,0,1.046,1.019c.372.042.747.068,1.13.087a.684.684,0,0,0,.717-.678V39.421a.683.683,0,0,0-.66-.679,12.912,12.912,0,0,1,0-25.79.683.683,0,0,0,.66-.679V6.835a.683.683,0,0,0-.715-.679q-.572.024-1.132.08A1.226,1.226,0,0,0,16.8,7.263L16.37,9.88a16.086,16.086,0,0,0-5.609,2.331L8.6,10.661a1.222,1.222,0,0,0-1.467.014A18.065,18.065,0,0,0,5.77,11.918a15.675,15.675,0,0,0-1.243,1.368,1.222,1.222,0,0,0-.014,1.468l1.548,2.161a16.1,16.1,0,0,0-2.329,5.611l-2.614.428A1.211,1.211,0,0,0,.1,24a16.815,16.815,0,0,0,0,3.667,1.228,1.228,0,0,0,1.019,1.076Z",
    transform: "translate(0.001 -6.156)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_132_",
    d: "M154.095,151.126a10.186,10.186,0,0,0,0,20.331.623.623,0,0,0,.649-.629V151.755a.623.623,0,0,0-.649-.629Z",
    transform: "translate(-135.053 -141.598)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_131_",
    d: "M323.684,35.54h-3.4V36.9h3.4a2.043,2.043,0,0,0,2.037-2.037v-4.2a2.037,2.037,0,1,0-1.358,0v4.2A.679.679,0,0,1,323.684,35.54Z",
    transform: "translate(-299.24 -25.354)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_130_",
    d: "M320.288,203.845h6.791a.679.679,0,1,0,0-1.358h-6.791Z",
    transform: "translate(-299.239 -189.584)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_129_",
    d: "M320.288,431.164h3.4a.679.679,0,0,1,.679.679v4.2a2.037,2.037,0,1,0,1.358,0v-4.2a2.043,2.043,0,0,0-2.037-2.037h-3.4v1.358Z",
    transform: "translate(-299.239 -401.964)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_128_",
    d: "M330.474,347.145H320.288V348.5h10.186a.679.679,0,0,1,.679.679v3.52a2.037,2.037,0,1,0,1.358,0v-3.52A2.043,2.043,0,0,0,330.474,347.145Z",
    transform: "translate(-299.239 -324.735)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_127_",
    d: "M337.264,274.816a2.037,2.037,0,0,0-1.912,1.358H320.288v1.358h15.064a2.034,2.034,0,1,0,1.912-2.716Z",
    transform: "translate(-299.239 -257.16)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_126_",
    d: "M327.758,389.154a.679.679,0,0,0-.679-.679h-6.791v1.358h6.791A.679.679,0,0,0,327.758,389.154Z",
    transform: "translate(-299.239 -363.349)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_125_",
    d: "M332.51,127.176v-3.52a2.037,2.037,0,1,0-1.358,0v3.52a.679.679,0,0,1-.679.679H320.287v1.358h10.186A2.043,2.043,0,0,0,332.51,127.176Z",
    transform: "translate(-299.238 -112.236)",
    fill: "#fafafa"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnalogyExpertiesIcon);
export default __webpack_public_path__ + "static/media/technalogy_experties_icon.ec3765cca35d0193ad2b0c05029b035c.svg";
export { ForwardRef as ReactComponent };